import React from 'react'
//import { injectIntl, intlShape } from 'react-in'
import ReactRouterPropTypes from 'react-router-prop-types'
import PropTypes from 'prop-types'

import { urls, pushHistoryWithErrorNotFound } from '../../utils/routing'

import Back from '../Buttons/Back/Back'
import Content from '../Content/Content'
import Error from '../Error/Error'
import Main from '../Main/Main'
import TitleMajor from '../TitleMajor/TitleMajor'

import {
    COMMON_ERROR,
    TO_LANDING,
} from '../../translations'

import { documentTitle } from './translations'

import styles from './ContentPage.module.css'

class ContentPage extends React.Component {
    static propTypes = {
        data: PropTypes.shape({
            content: PropTypes.string,
            title: PropTypes.string,
        }).isRequired,
        isError: PropTypes.bool.isRequired,
        isErrorNotFound: PropTypes.bool.isRequired,
        isFetched: PropTypes.bool.isRequired,
        isFetching: PropTypes.bool.isRequired,

        history: ReactRouterPropTypes.history.isRequired,
        //match: ReactRouterPropTypes.match.isRequired,

        //intl: intlShape,

        fetchContentPage: PropTypes.func.isRequired,
    }

    componentDidMount() {
        this.props.fetchContentPage(this.getSlug(this.props))
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.isErrorNotFound) {
            pushHistoryWithErrorNotFound(this.props.history)
        }
        
        if (this.props.location.state !== nextProps.location.state) { // this.props.match !== nextProps.match
            this.props.fetchContentPage(this.getSlug(nextProps))
        }

        this.setDocumentTitle(nextProps)
    }

    setDocumentTitle(props) {
        if (props.data.title) {
            document.title = documentTitle(props.data.title) //this.props.intl.formatMessage(messages.documentTitle, { pageTitle: props.data.title })
        }
    }

    getSlug(props) {
        const slug = props.location.pathname.toString().slice(6).replace(/^\/|\/$/g, '');
        if (window.__PRELOADED_STATE__.pages[slug]) {
            return window.__PRELOADED_STATE__.pages[slug] // props.match.params.slug.toString().replace(/\/$/, '')
        } else {
            pushHistoryWithErrorNotFound(props.history)
        }
    }


    renderTitle() {
        if (this.props.isError) {
            return null
        }

        return (
            <TitleMajor>{this.props.data.title}</TitleMajor>
        )
    }

    renderContent() {
        if (this.props.isError) {
            return (
                <Error>{COMMON_ERROR}</Error>
            )
        }

        return (
            <div className={styles.inner}>
                <Content>
                    <div dangerouslySetInnerHTML={{ __html: this.props.data.content }} />
                </Content>
            </div>
        )
    }

    render() {
        if (!this.props.isFetched || this.props.isFetching) {
            return null
        }

        return (
            <Main>
                <div className={styles.base}>
                    <div className={styles.head}>
                        <Back caption={TO_LANDING} to={urls.landing} location={this.props.location} />
                        {this.renderTitle()}
                    </div>
                    <div className={styles.body}>
                        {this.renderContent()}
                    </div>
                </div>
            </Main>
        )
    }
}

export default ContentPage
//export default injectIntl(ContentPage)